import { registerComponent } from '@gig/magic-common';
import CodeEntryComponent from './code-entry.vue.js';

var CodeEntry = registerComponent(CodeEntryComponent);

export { CodeEntry };
